var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scrubber-container--large",style:({ left: _vm.scrubberPos }),on:{"mousedown":_vm.mouseDown}},[_c('div',{staticClass:"scrubber__stick"}),_c('div',{staticClass:"scrubber__time"},[_c('div',[_vm._v(_vm._s(_vm.currentFormattedTime))]),_c('div',[_vm._v(_vm._s(_vm.duration))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }